import React, { useContext } from 'react';

import { SkeletonLoader, TabletScreen, MobileScreen, StaticContext } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

const AppListingSkeleton = props => {
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <TabletScreen defaultMatches={isDesktop}>
        <SkeletonLoader width={776} height={258} {...props}>
          <rect x="0" y="0" ry="0" width="236" height="258" />
          <rect x="260" y="0" ry="0" width="236" height="258" />
          <rect x="540" y="0" ry="0" width="236" height="258" />
        </SkeletonLoader>
      </TabletScreen>

      <MobileScreen defaultMatches={!isDesktop}>
        <SkeletonLoader height={178} width={320} {...props}>
          <rect x="0" y="0" ry="0" width="230" height="25" />

          <rect x="00" y="50" ry="0" width="50" height="50" />
          <rect x="70" y="50" ry="0" width="180" height="15" />
          <rect x="70" y="75" ry="0" width="230" height="8" />
          <rect x="70" y="90" ry="0" width="230" height="8" />

          <rect x="0" y="130" ry="0" width="50" height="50" />
          <rect x="70" y="130" ry="0" width="180" height="15" />
          <rect x="70" y="155" ry="0" width="230" height="8" />
          <rect x="70" y="170" ry="0" width="230" height="8" />
        </SkeletonLoader>
      </MobileScreen>
    </>
  );
};

export default AppListingSkeleton;
